import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-pill.css';
import { EGDSPillContainerAlignments } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSPillContainer = props => {
  const {
    children,
    className,
    wrap,
    align,
    dataTestId
  } = props;
  const baseClassName = 'uitk-pill-container';
  const wrapperClassName = getClassNameList(baseClassName, className, align && EGDSPillContainerAlignments.get(align), {
    [`${baseClassName}-wrap`]: wrap
  });
  return jsx("div", {
    className: wrapperClassName,
    "data-stid": dataTestId,
    children: children
  });
};
EGDSPillContainer.displayName = 'EGDSPillContainer';
export { EGDSPillContainer };